export default __webpack_public_path__ + "static/Enrolment_Policy-960fa872958800355735b02c5e38c9df.pdf";